<template>
    <div class="checkbox-theme">
        <p class="label">{{ label }}</p>
        <template v-for="item in items">
            <v-checkbox v-model="selected" hide-details="auto" class="mt-1" :key="item.id" :value="item.id">
                <template v-slot:label>
                    <span class="black--text">{{ item.name }}</span>
                </template>
            </v-checkbox>
        </template>
    </div>
</template>

<script>
  import ThemeService from '@/services/theme.service.js';

  export default {
    name: "ThemeCheckboxInput",
    props: {
      value: Array,
      label: { type: String, default: 'Thème(s) d\'étude(s)'}
    },
    data: () => ({
      items: [],
    }),
    computed: {
      selected: {
         get() {
           return this.value
         },
         set(value) {
           this.$emit('input', value);
         }
       }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        ThemeService.getList().then(({data}) => {
          _this.items = data;
        });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
